<template>
	<div class="container toc">
		<page-title>Table of Contents</page-title>
		<div class="content">
			<MenuItems />
		</div>
	</div>
</template>

<script>
	import PageTitle from '@/ui/components/PageTitle';
	import MenuItems from '@/ui/views/MenuItems';

	export default {
		components: {
			PageTitle,
			MenuItems
		}
	};
</script>


